import { logger } from '../../utils/logger';
import { postToSapHost } from '../sap-context/cti-origin.util';

export function signalWidgetReady(): void {
  if (window.parent !== window) {
    postToSapHost({ type: 'WIDGET_READY' });
    logger.debug('[SAP CTI] Signaled WIDGET_READY to parent');
  }
}
